export default __webpack_public_path__ + "static/media/invictus_banner_mweb.4d0a4991.webp";